import { MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { NewOffsiteCampaignProvider } from '../context/UseNewOffsiteCampaignContext';
import NewOffsiteCampaignWizard from './NewOffsiteCampaignWizard';

export const NewOffsiteCampaignWizardPage: React.FC = () => (
  <NewOffsiteCampaignProvider>
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>

      <Page padding={0}>
        <NewOffsiteCampaignWizard />
      </Page>
    </MainArea>
  </NewOffsiteCampaignProvider>
);

export default NewOffsiteCampaignWizardPage;
